import { render, staticRenderFns } from "./SmallHint.vue?vue&type=template&id=6d6dbedd&scoped=true"
import script from "./SmallHint.vue?vue&type=script&lang=js"
export * from "./SmallHint.vue?vue&type=script&lang=js"
import style0 from "./SmallHint.vue?vue&type=style&index=0&id=6d6dbedd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6dbedd",
  null
  
)

export default component.exports